import React, { useEffect, useState } from "react";
import {
    useCreateItem,
    useDeleteItem,
    useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { dateConvertToPayloadBookingFormat } from "../../../components/admin/setup/helper/Helper";
import { useAtom } from "jotai";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../../_helper/constant/Permission";
import moment from "moment";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import BlockSlotCard from "./BlockSlotCard";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import CuScreenLoader from "../../../common_component/component/CuScreenLoader";
import CuInput from "../../../all-patient/components/CuInput";
import CuButton from "../../../all-patient/components/CuButton";
import { getStartAndEndTime } from "../../_helper/utils.js/utils";
import { RiEdit2Fill } from "react-icons/ri";
import { FaTrash } from "react-icons/fa";
import CuModal from "../../../common_component/component/CuModal";
import Confirmation from "../../../common_component/component/Confirmation";

export const BlockSlot = () => {
    const [data, setData] = useState({
        date: "",
        end_date: "",
        start: "00:00",
        end: "23:59",
    });
    const [customdate, setCustomDate] = useState(true);
    const [isFullday, setIsFullDay] = useState(false);
    const { role_id } = useCurrentRole();
    const [clinic] = useAtom(clinicAtom);
    const [formData, setFormData] = useState();
    const [selectedIndex, setSelectedIndex] = useState("");
    const [openDelete, setOpenDelete] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    const blockedSlotMutation = useCreateItem(ApiEndPoint.QM_SC_SLOTS);

    const updateBlockedMutation = useUpdateItem(ApiEndPoint.QM_SC_SLOTS);

    const deleteBlockedMutation = useDeleteItem(ApiEndPoint.QM_SC_SLOTS);

    const queryString = `?action=getBlockedSlots&clinic_id=${clinic?.id}&frontend=True&doctor_id=${role_id}`;

    const handleEdit = (index) => {
        const selectedItem = formData[index];
        setData({
            date: selectedItem.start_date,
            end_date: selectedItem.end_date,
            start: selectedItem.start_time,
            end: selectedItem.end_time,
        });
        setIsEditing(true);
        setEditIndex(index);
    };

    const { data: blockedSlots, isLoading: isSlotLoading } = useItemsFilter(
        ApiEndPoint.QM_SC_SLOTS,
        queryString,
        clinic?.id ? true : false
    );

    useEffect(() => {
        if (blockedSlots) {
            const mapped =
                blockedSlots?.map((item) => {
                    const startTimeIST = moment(item?.start_time);

                    const endTimeIST = moment(item?.end_time);

                    const formattedStartTimeIST = startTimeIST
                        .format("YYYY-MM-DDTHH:mm")
                        .split("T");

                    const formattedEndTimeIST = endTimeIST
                        .format("YYYY-MM-DDTHH:mm")
                        .split("T");

                    const startDateParts = formattedStartTimeIST[0];
                    const endDateParts = formattedEndTimeIST[0];
                    const startTimeParts = formattedStartTimeIST[1];
                    const endTimeParts = formattedEndTimeIST[1];

                    return {
                        start_date: startDateParts,
                        end_date: endDateParts,
                        start_time: startTimeParts,
                        end_time: endTimeParts,
                        id: item.id,
                    };
                }) || [];
            setFormData(mapped);
        }
    }, [blockedSlots]);

    const handleCustomDateChange = () => {
        setCustomDate(true);
        setIsFullDay(false);
    };

    const handleFullDayChange = () => {
        setCustomDate(false);
        setIsFullDay(true);
    };

    const handleSave = (e) => {
        e.preventDefault();

        const { date, end_date, start, end } = data;
        const result = [];

        // Define the start and end dates
        const startDate = new Date(date);
        const endDate = new Date(end_date);

        // Define a variable to hold the current date, initialized to the start date
        let currentDate = new Date(startDate);

        // Iterate over each date until the end date is reached
        while (currentDate <= endDate) {
            if (isFullday) {
                const { start_time: startTime, end_time: endTime } =
                    getStartAndEndTime(
                        currentDate.toISOString(),
                        "00:00",
                        "23:59",
                        currentDate.toISOString()
                    );
                result.push({
                    start_time: dateConvertToPayloadBookingFormat(startTime),
                    end_time: dateConvertToPayloadBookingFormat(endTime),
                    status: "blocked",
                    doctor_user: role_id,
                });
            } else {
                const { start_time: startTime, end_time: endTime } =
                    getStartAndEndTime(
                        currentDate.toISOString(),
                        start,
                        end,
                        currentDate.toISOString()
                    );
                result.push({
                    start_time: dateConvertToPayloadBookingFormat(startTime),
                    end_time: dateConvertToPayloadBookingFormat(endTime),
                    status: "blocked",
                    doctor_user: role_id,
                });
            }
            // Move to the next day
            currentDate.setDate(currentDate.getDate() + 1);
        }

        const payload = {
            action: "postBlockedSlots",
            backend: "True",
            block_list: result,
            clinic_id: clinic?.id,
        };

        blockedSlotMutation.mutate(payload, {
            onSuccess: () => {
                toast.success("Blocked Sucessfully");
            },
            onError: (err) => {
                toast.error(err.response.data.message);
            },
        });
    };

    const handleCancel = () => {
        // Handle cancel logic
        setData({
            date: "",
            end_date: "",
            start: "00:00",
            end: "23:59",
        });
        setCustomDate(true);
        setIsFullDay(false);
        setIsEditing(false);
    };

    const buttonStyle = {
        backgroundColor: "#C7EAC9",
        color: "#000000",
        border: "none",
        borderRadius: "4px",
        padding: "10px",
        fontSize: "16px",
        width: "190px",
        cursor: "pointer",
        // margin: "6px",
        fontWeight: "400",
    };

    const handleSubmit = (index) => {
        const { date, end_date, start, end } = data;
        const startDate = new Date(date);
        const endDate = new Date(end_date);

        // Define a variable to hold the current date, initialized to the start date
        let currentDate = new Date(startDate);
        const { start_time: startTime, end_time: endTime } = getStartAndEndTime(
            currentDate.toISOString(),
            start,
            end,
            currentDate.toISOString()
        );

        const payload = {
            id: formData[index]?.id,
            action: "patchBlockedSlots",
            clinic_id: clinic?.id,
            start_time: dateConvertToPayloadBookingFormat(startTime),
            end_time: dateConvertToPayloadBookingFormat(endTime),
            backend: "True",
        };
        updateBlockedMutation.mutate(
            {
                data: payload,
            },
            {
                onSuccess: () => {
                    toast.success("Updated blocked slot sucessfully");
                    setData({
                        date: "",
                        end_date: "",
                        start: "",
                        end: "",
                    });
                    setIsEditing(false);
                },
                onError: (err) => {
                    toast.error(err.response.data.message);
                },
            }
        );
    };

    const handleOpenDelete = (index) => {
        setSelectedIndex(index);
        setOpenDelete(true);
    };

    const handleDeleteClick = () => {
        if (formData[selectedIndex]?.id) {
            const payload = {
                action: "delBlockedSlots",
                id: formData[selectedIndex]?.id,
                frontend: "True",
                clinic_id: clinic?.id,
            };

            deleteBlockedMutation.mutate(
                {
                    data: payload,
                },
                {
                    onSuccess: () => {
                        toast.success("Blocked slot deleted successfully!");
                        // refetch();
                        setSelectedIndex("");
                        setOpenDelete(false);
                    },
                    onError: (error) => {
                        toast.error(error.response.data.message);
                        setSelectedIndex("");
                        setOpenDelete(false);
                    },
                }
            );
        }
    };

    return (
        <div>
            {/* Other JSX... */}
            <br />
            <form>
                <div className="flex items-center gap-4">
                    <label className="cu-patient-radio-cont flex items-center">
                        <input
                            type="radio"
                            name="dateOption"
                            value="customDate"
                            onChange={handleCustomDateChange}
                            checked={customdate}
                        />
                        <span className="cu-checkmark-radio"></span>
                        Custom Date
                    </label>
                    {!isEditing && (
                        <label className="cu-patient-radio-cont flex items-center">
                            <input
                                type="radio"
                                name="dateOption"
                                value="fullDay"
                                onChange={handleFullDayChange}
                                checked={isFullday}
                            />
                            <span className="cu-checkmark-radio"></span>
                            Full Day
                        </label>
                    )}
                </div>

                <div className="flex gap-4">
                    {customdate ? (
                        <>
                            <div>
                                <label className="block">Start date</label>
                                <CuInput
                                    type="date"
                                    name="date"
                                    required
                                    value={data?.date}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            date: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div>
                                <label className="block">End date</label>
                                <CuInput
                                    type="date"
                                    name="date"
                                    required
                                    value={data?.end_date}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            end_date: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <label className="block">Start date</label>
                                <CuInput
                                    type="date"
                                    name="date"
                                    required
                                    value={data?.date}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            date: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div>
                                <label className="block">End date</label>
                                <CuInput
                                    type="date"
                                    name="date"
                                    required
                                    value={data?.end_date}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            end_date: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                        </>
                    )}

                    {!isFullday && (
                        <>
                            <div>
                                <label className="block">Start time</label>
                                <CuInput
                                    type="time"
                                    required
                                    value={data?.start}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            start: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div>
                                <label className="block">End time</label>
                                <CuInput
                                    className="input"
                                    type="time"
                                    required
                                    value={data?.end}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            end: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="">
                    <div className="flex gap-4 my-3">
                        <CuButton
                            style={{
                                ...buttonStyle,
                                backgroundColor: "#CDCDCD",
                                width: "180px",
                            }}
                            className="customButton"
                            onClick={handleCancel}>
                            Cancel
                        </CuButton>

                        <CuButton
                            className="customButton"
                            style={{
                                ...buttonStyle,
                                width: "180px",
                            }}
                            onClick={
                                isEditing
                                    ? () => handleSubmit(editIndex)
                                    : handleSave
                            }
                            disabled={
                                blockedSlotMutation.isLoading ||
                                updateBlockedMutation.isLoading
                            }
                            type="submit"
                            isLoading={
                                blockedSlotMutation.isLoading ||
                                updateBlockedMutation.isLoading
                            }>
                            {isEditing ? "Update" : "Save"}
                        </CuButton>
                    </div>
                </div>
            </form>

            <hr />

            <div className="cu-setup-table mt-5">
                <table>
                    <thead className="cu-setup-table-header">
                        <tr>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData?.map((item, i) => {
                            const startTime = moment(item?.start_time).isValid()
                                ? moment(item?.start_time)
                                : moment(
                                      item?.start_date + "T" + item?.start_time
                                  );
                            const endTime = moment(item?.end_time).isValid()
                                ? moment(item?.end_time)
                                : moment(item?.end_date + "T" + item?.end_time);
                            return (
                                <tr key={i}>
                                    <td>{startTime.format("DD MMM YYYY")}</td>
                                    <td>{endTime.format("DD MMM YYYY")}</td>
                                    <td>{startTime.format("hh:mm A")}</td>
                                    <td>{endTime.format("hh:mm A")}</td>
                                    <td>
                                        <div className="cu-setup-table-action-col">
                                            <RiEdit2Fill
                                                size={18}
                                                className="cursor-pointer"
                                                onClick={() => handleEdit(i)}
                                            />
                                            <FaTrash
                                                size={16}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                    handleOpenDelete(i)
                                                }
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {openDelete && (
                <CuModal closeModal={() => setOpenDelete(false)}>
                    <Confirmation
                        heading={`Delete this block slot`}
                        onCancel={() => setOpenDelete(false)}
                        onClick={handleDeleteClick}
                        loading={deleteBlockedMutation.isLoading}
                    />
                </CuModal>
            )}

            {isSlotLoading && <CuScreenLoader />}
        </div>
    );
};
